module.exports = "/_next/static/images/institute-of-mine-seismology-dfc07c3c26df2de4d356dc7959e29d18.png";